import type { AdSetupResultAdapter } from "@mobsuccess-devops/lcm-client/schemas/adSetupResultAdapter";

export function getAdLabel(ad: AdSetupResultAdapter): string {
  const format = ad.format === "WIDE_ANGLE" ? "HALF_PAGE" : ad.format;
  const asset = ad.asset.asset;
  const assetName =
    "name" in asset && typeof asset.name === "string" ? asset.name : "";
  return [format, ad.variation?.name, assetName].filter(Boolean).join(" - ");
}
